import { Bob } from "../stores/Bob";
import { makeSpreadsheetLine } from "./spreadSheet";
import { makeTransactionsListLine } from "./transactionsList";
import {
  makeTransactionsPage,
  TransactionViewOutput,
} from "./transactionViewer";
import { CurrencySnapshot } from "./types";

export interface OurOnchainInboundTransaction {
  receiving_address: string;
  transaction_identifier: string; // txid
  vout_index: number;
  outpoint: string; // "txid:vout"
  confirmations: number;
  satoshis_amount: number;
  created_at: number;
  currency_snapshot: CurrencySnapshot;
  is_considered_confirmed: boolean;
}

export const makeSpreadsheetLineForOnchainInbound = (
  txData: OurOnchainInboundTransaction,
  bob: Bob,
) => {
  return makeSpreadsheetLine({
    type: "Onchain Received",
    status: txData.is_considered_confirmed ? "Confirmed" : "Pending",
    uuid: txData.outpoint,
    createdAtInteger: txData.created_at,
    currencySnapshot: txData.currency_snapshot,
    currency: bob.currencyCode,
    amountSatoshis: txData.satoshis_amount,
    isCredit: true,
    comment: null,
    payRequest: null,
    routingFeeSatoshis: null,
    platformFeeSatoshis: null,
    lightningAddress: null,
    onchainTransactionId: txData.transaction_identifier,
    onchainReceivingAddress: txData.receiving_address,
    onchainConfirmations: txData.confirmations,
  });
};

export const makeTransactionsListLineForOnchainInbound = (
  txData: OurOnchainInboundTransaction,
  bob: Bob,
) => {
  const confirmationLabel = txData.is_considered_confirmed
    ? "Onchain Received"
    : "Pending Onchain";

  return makeTransactionsListLine({
    amountSatoshis: txData.satoshis_amount,
    label: confirmationLabel,
    isConfirmed: txData.is_considered_confirmed,
    createdAtInteger: txData.created_at,
    comment: null,
    currencySnapshot: txData.currency_snapshot,
    currency: bob.currencyCode,
    isCredit: true,
    modelName: "OnchainInboundTransaction",
    uuid: txData.outpoint,
    lightningAddress: null,
    zapName: null,
    zapPictureUrl: null,
    onchainTransactionId: txData.transaction_identifier,
    onchainReceivingAddress: txData.receiving_address,
    onchainConfirmations: txData.confirmations,
  });
};

export type OnchainTransactionViewOutput = TransactionViewOutput & {
  transactionId: string;
  receivingAddress: string;
  confirmations: number;
  isConsideredConfirmed: boolean;
  mempoolTxUrl: string;
  mempoolAddressUrl: string;
};

export const makeTransactionPageDataForOnchainInbound = (
  txData: OurOnchainInboundTransaction,
  bob: Bob,
): OnchainTransactionViewOutput => {
  const baseData = makeTransactionsPage({
    header: txData.is_considered_confirmed
      ? "Onchain Received"
      : "Onchain Pending",
    uuid: txData.outpoint,
    createdAtInteger: txData.created_at,
    currencySnapshot: txData.currency_snapshot,
    currency: bob.currencyCode,
    amountSatoshis: txData.satoshis_amount,
    isCredit: true,
    comment: null,
    payRequest: null,
    routingFeeSatoshis: null,
    platformFeeSatoshis: null,
    lightningAddress: null,
  });

  return {
    ...baseData,
    transactionId: txData.transaction_identifier,
    receivingAddress: txData.receiving_address,
    confirmations: txData.confirmations,
    isConsideredConfirmed: txData.is_considered_confirmed,
    mempoolTxUrl: `https://mempool.space/tx/${txData.transaction_identifier}`,
    mempoolAddressUrl: `https://mempool.space/address/${txData.receiving_address}`,
  };
};
